export type CheckpointTag = {
  unit: "epoch" | "step";
  value: number;
};

// 체크포인트 디렉터리 태그. budget unit 에 따라 `epoch_200` 또는 `step_0100000` 이다.
// 평가 화면과 학습 화면이 같은 태그를 해석한다. 그래서 page 가 아니라 training 계약이 소유한다.
const CHECKPOINT_TAG_RE = /^(epoch|step)_(\d+)$/;

export function parseCheckpointTag(tag: string | null | undefined): CheckpointTag | null {
  if (typeof tag !== "string") return null;
  const match = tag.trim().match(CHECKPOINT_TAG_RE);
  if (match === null) return null;
  return { unit: match[1] as CheckpointTag["unit"], value: Number.parseInt(match[2], 10) };
}

// MLflow run 딥링크. BE 가 보낸 host·experiment id·run id 를 조립하는 공용 계약.
export function mlflowRunDeepLink(
  baseUrl: string | null | undefined,
  experimentId: string | null | undefined,
  runId: string | null | undefined,
): string | null {
  if (!baseUrl?.trim() || !experimentId?.trim() || !runId?.trim()) {
    return null;
  }
  const base = baseUrl.replace(/\/+$/, "");
  const experiment = encodeURIComponent(experimentId);
  const run = encodeURIComponent(runId);
  return `${base}/#/experiments/${experiment}/runs/${run}`;
}
